import { ColumnType } from '../common/interfaces/IColumn.interface';
import { FilterOperator, OrderDirection } from '../common/models/DataTableFilter.model';

export class RecordsComparatorBase {

    prepareArgumentFn: Function;
    property: string;
    constructor(property: string, prepareFn: Function = null) {
        this.prepareArgumentFn = prepareFn;
        this.property = property;
    }

    prepareProperty = (item) => {
        let propertyValue = item[this.property];
        propertyValue = this.prepareValue(propertyValue);
        return propertyValue;
    }

    prepareValue = (item) => {
        if (this.prepareArgumentFn) {
            item = this.prepareArgumentFn(item);
        }
        return item;
    }

}

export class FilterComparator extends RecordsComparatorBase {
    operator: FilterOperator;
    filterValue: any;
    constructor(operator: FilterOperator, property: string, filterValue: any, prepareFn: Function = null) {
        super(property, prepareFn);
        this.operator = operator;
        this.filterValue = this.prepareValue(filterValue);
    }
    compare = (a) => {
        const aValue = this.prepareProperty(a);
        const bValue = this.filterValue;
        switch (this.operator) {
            case FilterOperator.Bigger: {
                return aValue > bValue;
            }
            case FilterOperator.BiggerOrEqual: {
                return aValue >= bValue;
            }
            case FilterOperator.Smaller: {

                return aValue < bValue;
            }
            case FilterOperator.SmallerOrEqual: {
                return aValue <= bValue;
            }
            default:
                return aValue === bValue;
        }
    }
}

export class OrderComparator extends RecordsComparatorBase {
    columnType: ColumnType;
    direction: OrderDirection;

    constructor(columnType: ColumnType, direction: OrderDirection, property: string, prepareFn: Function = null) {
        super(property, prepareFn);

        if (!columnType && columnType !== ColumnType.Number) {
            throw Error('Column missing type, property: ' + property);
        }

        this.columnType = columnType;
        this.direction = direction;
    }
    compare = (a, b) => {
        let aValue = this.prepareProperty(a);
        let bValue = this.prepareProperty(b);
        switch (this.columnType) {
            case (ColumnType.Number): {
                let a = isNaN(parseInt(aValue, 10)) ? 0 : parseInt(aValue, 10);
                let b = isNaN(parseInt(bValue, 10)) ? 0 : parseInt(bValue, 10);

                return this.respond(b - a);
            }
            case (ColumnType.Boolean): {
                return this.respond(bValue - aValue);
            }
            case (ColumnType.Date):
            case (ColumnType.DateTime): {
                return this.respond(bValue - aValue);
            }
            case (ColumnType.Text): {
                aValue = aValue ? aValue.toString().toLowerCase(): "";
                bValue = bValue ? bValue.toString().toLowerCase(): "";
                return this.respond(aValue > bValue ? -1 : (aValue === bValue ? 0 : 1));
            }
        }
    }
    private respond(output) {
        return this.direction === OrderDirection.DESC ? output : (output * -1); // multiplication with -1 reverses order
    }
}
